<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="ac_company.name,pr_detail,pr_orispeccode,pr_spec"
      placeholder="输入客户、物料进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="{name: 'SaleDeliveryReply', params: { item }}"
      >
        <div class="weui-cell__bd">
          <p>{{item.dt_cop}}</p>
          <p>{{item.dt_code}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.pr_detail}}</p>
          <p class="list-item-muted">{{item.pr_code}}</p>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    const me = this
    return {
      listUrl: "/api/purchase/delivery/deliverytrace/sale/list",
      params: {
        mode: "MAIN",
        number: 1,
        size: 99999
      },
      filters: [
        {
          type: "date",
          name: "DeliveryTrace.createTime"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          beforeChange: me.beforeFilterChange,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待回复"
            }
          ]
        }
      ]
    };
  },
  methods: {
    beforeFilterChange(filter, filterBar, next) {
      this.listUrl = '/api/purchase/delivery/deliverytrace/' + (filter.value == 1 ? 'replysale' : 'sale') + '/list'
      next()
    }
  }
}
</script>